import { labels as enLabels }  from './en.js';
import { labels as ptLabels }  from './pt.js';
import { labels as esLabels }  from './es.js';

const labels = {
    ...enLabels,
    ...ptLabels,
    ...esLabels
};

export { labels }